import { MapPin, Phone, MessageCircle, Navigation, Building2 } from "lucide-react";
import { toast } from "sonner";
import { PHONE_DISPLAY, PHONE_TEL, GOOGLE_PROFILE_URL } from "./data";

const MAP_EMBED =
    "https://maps.google.com/maps?q=The%20Tooth%20Care%20Dental%20Clinic%2C%20Mirpara%20Rd%2C%20Liluah%2C%20Howrah%2C%20West%20Bengal%20711203&t=&z=15&ie=UTF8&iwloc=&output=embed";

export const Contact = () => (
    <section id="contact" className="bg-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center mb-14">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">Visit Us</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Find The Tooth Care Dental Clinic
                </h2>
            </div>

            <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-stretch">
                <div className="flex flex-col gap-5" data-testid="contact-info">
                    <div className="bg-slate-50 rounded-2xl p-7 border border-slate-100 flex-1">
                        <span className="h-12 w-12 rounded-xl bg-teal-50 flex items-center justify-center mb-5">
                            <Building2 className="h-6 w-6 text-teal-600" strokeWidth={1.5} />
                        </span>
                        <h3 className="text-lg font-semibold text-slate-900 mb-3">The Tooth Care Dental Clinic</h3>
                        <div className="flex gap-3 mb-4">
                            <MapPin className="h-5 w-5 text-teal-600 shrink-0 mt-0.5" strokeWidth={1.8} />
                            <address className="not-italic text-sm leading-relaxed text-slate-600">
                                Ward No. 34, 117/13, Mirpara Rd,<br />
                                PO Bhattanagar, Bhatta Nagar,<br />
                                Liluah, Howrah,<br />
                                West Bengal 711203
                            </address>
                        </div>
                        <div className="flex gap-3 items-center">
                            <Phone className="h-5 w-5 text-teal-600 shrink-0" strokeWidth={1.8} />
                            <a href={PHONE_TEL} data-testid="contact-phone-link" className="text-sm font-semibold text-slate-800 transition-colors duration-200 hover:text-teal-700">
                                {PHONE_DISPLAY}
                            </a>
                        </div>
                    </div>

                    <div className="flex flex-wrap gap-3">
                        <a
                            href={PHONE_TEL}
                            data-testid="contact-call-btn"
                            className="inline-flex items-center gap-2 rounded-full bg-teal-600 px-6 py-3 text-sm font-semibold text-white shadow-[0_8px_20px_rgba(13,148,136,0.35)] transition-all duration-200 hover:bg-teal-700 hover:-translate-y-0.5"
                        >
                            <Phone className="h-4 w-4" />
                            Call Clinic
                        </a>
                        <button
                            type="button"
                            data-testid="contact-whatsapp-btn"
                            onClick={() => toast.info("WhatsApp chat will be connected in the next update.")}
                            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition-all duration-200 hover:border-teal-300 hover:text-teal-700 hover:-translate-y-0.5"
                        >
                            <MessageCircle className="h-4 w-4 text-teal-600" />
                            WhatsApp
                        </button>
                        <a
                            href={GOOGLE_PROFILE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-directions-btn"
                            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition-all duration-200 hover:border-teal-300 hover:text-teal-700 hover:-translate-y-0.5"
                        >
                            <Navigation className="h-4 w-4 text-teal-600" />
                            Get Directions
                        </a>
                    </div>
                </div>

                <div className="rounded-3xl overflow-hidden border border-slate-100 shadow-[0_20px_50px_rgba(2,44,40,0.1)] min-h-[320px]" data-testid="contact-map">
                    <iframe
                        title="The Tooth Care Dental Clinic location map"
                        src={MAP_EMBED}
                        className="w-full h-full min-h-[320px] lg:min-h-[440px] border-0"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    </section>
);
